import Protected from "./protected-route";
export default Protected;
